/* ============================================================
   Protocol 30 / 60-day choice — behaviour for snippets/protocol-plan-picker.liquid
   Loaded as an external deferred file (inline scripts proved unreliable on the
   Men's Protocol page).

   For every [data-ppick] on the page:
     • if it carries data-ppick-mount, move it into the hero buy box, directly
       above the price box ([data-buy] .pricebox);
     • on selection, rewrite the hero price block ([data-now]/[data-mpp-now],
       was, save, off, per-day, instalment), set window.__protoQty (read by
       skin-protocol.js / men-protocol.js), keep men-protocol.js's data-ot-*
       attributes in step, and set data-current-qty on the sticky bar.
   ============================================================ */
(function () {
  'use strict';

  function aed(c) {
    c = Math.round(Number(c) || 0);
    var frac = c % 100 !== 0;
    return 'AED ' + (c / 100).toLocaleString('en-AE', { minimumFractionDigits: frac ? 2 : 0, maximumFractionDigits: 2 });
  }

  function setup(root) {
    if (root.__pp) return;
    if (root.hasAttribute('data-ppick-mount')) {
      /* The Men's hero renders its attribute as "data-buydata-ot-now" (a Liquid
         whitespace-strip glues the two together), so [data-buy] does not exist
         there. Fall back to the .buy class, which both heroes have. */
      var target = document.querySelector('[data-buy] .pricebox, .buy .pricebox');
      if (!target) return; /* hero not on the page (yet) */
      if (root.nextElementSibling !== target) target.parentNode.insertBefore(root, target);
    }
    root.__pp = true;
    root.setAttribute('data-ppick-ready', '1');

    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-ppick-opt]'));
    var scope = root.closest('.shopify-section') || document;

    function set(sel, v) {
      Array.prototype.forEach.call(scope.querySelectorAll(sel), function (el) { if (el.textContent !== v) el.textContent = v; });
    }

    function apply(opt) {
      if (!opt) return;
      opts.forEach(function (o) { o.setAttribute('aria-checked', o === opt ? 'true' : 'false'); });
      var d = opt.dataset, qty = parseInt(d.ppQty, 10) || 1;
      var p = +d.ppP, c = +d.ppC, s = +d.ppS;
      var v = {
        now:  aed(p),
        was:  c > p ? aed(c) : '',
        save: s > 0 ? 'Save ' + aed(s) : '',
        off:  (+d.ppO) > 0 ? d.ppO + '% OFF' : '',
        day:  '≈ ' + aed(d.ppD) + '/day',
        inst: '4 × ' + aed(d.ppI)
      };
      window.__protoQty = qty;
      window.__protoPlanOverride = v; /* skin-protocol.js applyPlan() uses this */

      set('[data-now],[data-mpp-now]', v.now);
      set('[data-was],[data-mpp-was]', v.was);
      set('[data-save],[data-mpp-save]', v.save);
      set('[data-off],[data-mpp-off]', v.off);
      set('[data-day]', v.day);
      set('[data-inst]', v.inst);

      var buy = scope.querySelector('[data-buy][data-ot-now]');
      if (buy) {
        buy.setAttribute('data-ot-now', v.now);
        buy.setAttribute('data-ot-was', v.was);
        buy.setAttribute('data-ot-save', v.save);
        buy.setAttribute('data-ot-off', v.off);
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-stickybar]'), function (b) { b.setAttribute('data-current-qty', String(qty)); });
      try { document.dispatchEvent(new CustomEvent('protocol:plan', { detail: { qty: qty, prices: v } })); } catch (e) {}
    }

    function current() { return root.querySelector('[data-ppick-opt][aria-checked="true"]') || opts[opts.length - 1]; }

    opts.forEach(function (o, i) {
      o.addEventListener('click', function (e) { e.preventDefault(); apply(o); });
      o.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = opts[(i + 1) % opts.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = opts[(i - 1 + opts.length) % opts.length];
        if (n) { e.preventDefault(); n.focus(); apply(n); }
      });
    });

    apply(current());
    /* page JS may repaint the price block after us — re-assert */
    root.__ppAgain = function () { apply(current()); };
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppick]'), function (root) {
      try { setup(root); } catch (e) { if (window.console) console.warn('[protocol-plan-picker]', e); }
    });
  }
  function again() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ppick]'), function (root) { if (root.__ppAgain) root.__ppAgain(); });
  }

  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); setTimeout(again, 0); });
  else setTimeout(again, 0);
  window.addEventListener('load', function () { boot(); setTimeout(again, 0); setTimeout(again, 400); });
  /* theme editor re-renders sections in place */
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(); again(); }, 0); });
})();
